module.exports = __webpack_public_path__ + "img/corn.be5030ca.webp";